module.exports = __webpack_public_path__ + "img/vip_icon.4bbb33e8.png";